import React from "react";
import { useGetAccommodationSelectorValueQuery } from "@graphql";
import { Spinner } from "@components";
import { AccommodationSelectorValueProps } from "./utils";
import { AccommodationCard } from "../../../accommodations/AccommodationCard/AccommodationCard";

export function AccommodationSelectorValue(props: AccommodationSelectorValueProps) {
  const { data, loading, error } = useGetAccommodationSelectorValueQuery({
    variables: { id: props.value?.accommodationId },
    skip: !props.value?.accommodationId
  });

  if (!props.value?.accommodationId) {
    return (
      <div
        style={{
          padding: "6px 0 5px",
          width: "100%",
          cursor: props.disabled ? "default" : "pointer"
        }}
        onClick={props.disabled ? undefined : props.onOpen}
      >
        &nbsp;
      </div>
    );
  }

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    throw new Error(error.toString());
  }

  return (
    <AccommodationCard
      data={data.getAccommodationDetails}
      style={{ flex: 1, cursor: "pointer" }}
    />
  );
}
